import { USER_ROLES } from '../../auth/index';
import { LAYOUT_VALUES } from '../enums';

const PERMISSIONS = [
	USER_ROLES.CSM,
	USER_ROLES.IMPLEMENTATION,
	USER_ROLES.LANGOS_APP,
	USER_ROLES.OPS,
	USER_ROLES.OWNER,
	USER_ROLES.LANGOPS,
	USER_ROLES.ADMIN,
	USER_ROLES.CONTENT_SUBMITTER,
	USER_ROLES.CONTENT_SUBMITTER_RESTRICTED,
];

export default {
	PROJECTS: {
		ACTIVE: true,
		NAME: 'manage-web-order',
		LABEL: 'Projects',
		ICON: 'folder-empty',
		PATH: '/projects/:section',

		CHILDREN: [
			'PROJECTS_LIST',
			'PROJECTS_CREATE',
			'PROJECTS_DETAIL',
			'PROJECTS_DRAFT',
			'PROJECT_CREATION_INTRO',
		],
		DISPLAY_CHILDREN: false,
		PERMISSIONS,
	},
	PROJECTS_LIST: {
		ACTIVE: true,
		NAME: 'projects-list',
		LABEL: 'Projects List',
		PARAMS: {
			section: 'all',
		},
		PERMISSIONS,
	},
	PROJECT_CREATION_INTRO: {
		ACTIVE: true,
		NAME: 'create-intro',
		LABEL: 'Create Project Intro',
		LAYOUT: LAYOUT_VALUES.FULLSCREEN,
		PARAMS: {
			section: 'create-intro',
		},
		PERMISSIONS,
	},
	PROJECTS_CREATE: {
		ACTIVE: true,
		NAME: 'projects-create',
		LABEL: 'Create Project',
		LAYOUT: LAYOUT_VALUES.FULLSCREEN,
		PARAMS: {
			section: 'create-draft',
		},
		PERMISSIONS,
	},
	PROJECTS_DETAIL: {
		ACTIVE: true,
		NAME: 'projects-detail',
		LABEL: 'Project Detail',
		PARAMS: {
			section: ':projectId/orders',
		},
		PERMISSIONS,
	},
	PROJECTS_DRAFT: {
		ACTIVE: true,
		NAME: 'projects-draft',
		LABEL: 'Create Project',
		LAYOUT: LAYOUT_VALUES.FULLSCREEN,
		PARAMS: {
			section: ':projectId/draft',
		},
		PERMISSIONS,
	},
};
